import React, { useState, useRef } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTooltip,
  I2cTextarea,
  I2cPhoneField,
  I2cIcon,
  I2cSelect,
  I2cMenuItem,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { useFieldArray } from "react-hook-form";
import {
  whoConductKyc,
  cardOrderPlacement,
  channel,
  cardActivationChannel,
  pinManagememt,
  additionalPayment,
  paymentDistributionOpt,
  distributionMinimumPay,
  pinManagmentOptions,
  constumerPaymentOptions,
  lockboxServices,
} from "./FieldsListingLabels";
import "../../PrepaidComponents/Prepaid.scss";
import TooltipIcon from "../../../Components/SharedComponent/TooltipIcon/TooltipIcon";

export const deliquentPolicies = [
  {
    label: "Deactivate cardholder account",
    value: "deactivate cardholder account",
  },
  {
    label: "Deactivate cardholder account",
    value: "Deactivate cardholder account",
  },
];
const CreditLimits = ({ control, handleValueChanges, methods, errors }) => {
  const checkboxRef = useRef(null);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "pf_clm_delinquent", // Name of the array field in your form,
  });
  const [secondaryMethods, setShowSecondaryMethod] = useState(false);

  const handleAddSecondary = () => {
    setShowSecondaryMethod(true);
  };
  React.useEffect(() => {
    methods.trigger();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields]);

  const handleCardInfoChange = (event) => {
    let selectedCardInfo;
    if (isNaN(event)) selectedCardInfo = event.target.value;
    else selectedCardInfo = event;
    let updatedSelectedCardsInfo = [...methods.getValues("pf_credit_limit")];

    if (updatedSelectedCardsInfo.includes(selectedCardInfo)) {
      updatedSelectedCardsInfo = updatedSelectedCardsInfo.filter(
        (card) => card !== selectedCardInfo,
      );
    } else {
      updatedSelectedCardsInfo.push(selectedCardInfo);
    }
    methods.setValue("pf_credit_limit", updatedSelectedCardsInfo);
    handleValueChanges();
    methods.trigger();
  };

  const handleCardrequestChecksChanges = (value) => {
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_card_order_placement") ?? []),
    ];
    if (updatedSelectedOptions.includes(value)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== value,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(value);
    }
    methods.setValue("pf_card_order_placement", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };
  const handleMinPaymentAdditionalAmountChanges = (value) => {
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_min_payment_additional_amount") ?? []),
    ];
    if (updatedSelectedOptions.includes(value)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== value,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(value);
    }
    methods.setValue("pf_min_payment_additional_amount", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };
  const handleCardrequestChannelsChecksChanges = (value) => {
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_card_order_placement_channel") ?? []),
    ];
    if (updatedSelectedOptions.includes(value)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== value,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(value);
    }
    if (!updatedSelectedOptions.includes(5)) {
      methods.setValue("pf_card_order_placement_channel_other", "");
    }
    methods.setValue("pf_card_order_placement_channel", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };

  const handleCardActivationChannelsChecksChanges = (value) => {
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_card_activation_channel") ?? []),
    ];
    if (updatedSelectedOptions.includes(value)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== value,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(value);
    }
    if (!updatedSelectedOptions.includes(5)) {
      methods.setValue("pf_card_activation_channel_other", "");
    }
    methods.setValue("pf_card_activation_channel", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };

  const handleConsumerPaymentsChecksChanges = (value) => {
    let updatedSelectedOptions = [
      ...(methods.getValues("pf_consumer_payment_opt") ?? []),
    ];
    if (updatedSelectedOptions.includes(value)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== value,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(value);
    }
    if (!updatedSelectedOptions.includes(3)) {
      methods.setValue("pf_consumer_payment_opt_other", "");
    }
    methods.setValue("pf_consumer_payment_opt", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <div className="sub-heading mb-4">Credit Limit </div>
          <I2cCheckboxGroup
            label="Please confirm if you want the credit limits to be assigned based on your credit decisioning model or will these be defined manually."
            ref={checkboxRef}
          >
            <div i2c-grid="grid gap-sm">
              {[
                { label: "Assign limit based on credit decisioning", value: 0 },
                {
                  label: "Assign limit manually from the administrative portal",
                  value: 1,
                },
              ].map((card, index) => (
                <div key={index} i2c-grid="6@md">
                  <I2cListItem
                    variant="receipt"
                    label={card.label}
                    sublabel=""
                    value=""
                    type="checkbox"
                    checked={methods
                      .watch("pf_credit_limit")
                      .includes(card.value)}
                    onI2cCheckboxClicked={(e) =>
                      handleCardInfoChange(card.value)
                    }
                  >
                    <I2cCheckbox
                      slot="prefix"
                      value={card.value}
                      label=""
                      ignoreTab
                      filled
                      checked={methods
                        .watch("pf_credit_limit")
                        .includes(card.value)}

                      className="customCheckbox"
                    ></I2cCheckbox>
                  </I2cListItem>
                </div>
              ))}
            </div>
          </I2cCheckboxGroup>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">Credit Limit Modification </div>
            <div className="custom-label-light mb-16">
              Can the initially assigned credit limit be increased or decreased
              for the consumers in this card program?
            </div>
            <div className="single-field-wrapper ">
              <Controller
                name="pf_credit_limit_modification"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_credit_limit_modification")}
                    {...field}
                    name="pf_credit_limit_modification"
                    onI2cChange={(e) => {
                      if (e.target.value === "yes") {
                        append({
                          pf_clm_deliquency_action: "",
                          pf_clm_days_past_dueL: "",
                          pf_clm_days_month_opt: "Months",
                        });
                      } else {
                        methods.setValue("pf_clm_delinquent", []);
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    {["Yes", "No", "N/A"].map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_credit_limit_modification") ===
                          cp.toLocaleLowerCase()
                        }
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_credit_limit_modification &&
                    methods.formState.touchedFields.pf_credit_limit_modification
                    ? true
                    : false
                }
                message={
                  errors.pf_credit_limit_modification?.message ??
                  "Invalid input"
                }
              />
            </div>
          </div>
          {methods.watch("pf_credit_limit_modification") === "yes" && (
            <div i2c-grid="12">
              <div className="organize-tooltip mb-16">
                <div className="sub-heading">
                  Charge-Off Process and Delinquent Accounts Policy
                </div>
                <TooltipIcon content='Program managers can define actions to be performed on card accounts based on the DPD (Days Past Due). 
                                        For Example, deactivate card accounts, enforce penalties, charge off accounts, forfeit reward points or mark for collection.' />
              </div>
              {fields.map((row, index) => (
                <React.Fragment key={index}>
                  <div key={row.id} className="delinquent-fields mb-16">
                    <Controller
                      name="pf_clm_deliquency_action"
                      control={control}
                      render={({ field }) => (
                        <I2cSelect
                          {...field}
                          name="pf_clm_deliquency_action"
                          onI2cChange={(e) => {
                            methods.setValue(
                              `pf_clm_delinquent.${index}.pf_clm_deliquency_action`,
                              e.target.value,
                            );
                            methods.trigger();
                            handleValueChanges();
                          }}
                          value={
                            methods.watch(`pf_clm_delinquent`)[index]
                              ?.pf_clm_deliquency_action
                          }
                          label="Delinquency Action"
                          placeholder="Deactivate cardholder account"
                          size="large"
                          search
                        >
                          {deliquentPolicies.map((option) => (
                            <I2cMenuItem value={option.value}>
                              {option.label}
                            </I2cMenuItem>
                          ))}
                        </I2cSelect>
                      )}
                    />
                    <div className="fields-flex">
                      <Controller
                        name="pf_clm_days_past_dueL"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            key={field.name + index} // important to include key with field's id
                            className="single-input-field"
                            placeholder="Enter DPD"
                            value={
                              methods.watch(`pf_clm_delinquent`)[index]
                                .pf_clm_days_past_dueL
                            }
                            onI2cInput={(e) => {
                              methods.setValue(
                                `pf_clm_delinquent.${index}.pf_clm_days_past_dueL`,
                                e.target.value,
                              );
                              methods.trigger();
                            }}
                            onI2cChange={() => handleValueChanges()}
                            size="large"
                            label="Days Past Due (DPD)"
                            name={`pf_clm_days_past_dueL`}
                          >
                            <div slot="suffix">
                              <I2cSelect
                                className="suffix-select-custom"
                                placement="bottom-end"
                                size="medium"
                                connector
                                hoist
                                onI2cChange={(e) => {
                                  methods.setValue(
                                    `pf_clm_delinquent.${index}.pf_clm_days_month_opt`,
                                    e.target.value,
                                  );
                                  handleValueChanges();
                                  methods.trigger();
                                }}
                                value={
                                  methods.watch(`pf_clm_delinquent`)[index]
                                    .pf_clm_days_month_opt
                                }
                              >
                                <div style={{ display: "flex", flexDirection: "column", width: "100px" }}>
                                <I2cMenuItem key={"days"} value="days">
                                  Days
                                </I2cMenuItem>
                                <I2cMenuItem key={"months"} value="Months">
                                  Months
                                </I2cMenuItem>
                                </div>
                              </I2cSelect>
                            </div>
                          </I2cInput>
                        )}
                      />
                      <I2cButton
                        size="large"
                        variant="tertiary gray"
                        disabled={
                          methods.watch("pf_credit_limit_modification") ===
                          "yes" && index === 0
                        }
                        onClick={() => remove(index)}
                      >
                        <I2cIcon name="linear-trash" label="delete"></I2cIcon>
                      </I2cButton>
                    </div>
                  </div>
                  {/* {errors?.pf_clm_delinquent?.length  && (
                    <ErrorMessage
                      show={
                        errors?.pf_clm_delinquent[index]
                          ?.pf_clm_deliquency_action &&
                        methods.formState.touchedFields
                          ?.pf_clm_deliquency_action
                          ? true
                          : errors?.pf_clm_delinquent[index]
                                ?.pf_clm_days_past_dueL &&
                              methods.formState.touchedFields
                                ?.pf_clm_days_past_dueL
                            ? true
                            : false
                      }
                      message={
                        errors?.pf_clm_delinquent[index]
                          .pf_clm_deliquency_action?.message ??
                        errors?.pf_clm_delinquent[index].pf_clm_days_past_dueL
                          ?.message ??
                        "Invalid input"
                      }
                    />
                  )} */}
                </React.Fragment>
              ))}

              <div className="mt-16">
                <I2cButton
                  size="small"
                  variant="link color"
                  className=""
                  onClick={() => {
                    append({
                      pf_clm_deliquency_action: "",
                      pf_clm_days_past_dueL: "",
                      pf_clm_days_month_opt: "Months",
                    });
                  }}
                // disabled={errors?.pf_clm_delinquent?.length}
                >
                  <I2cIcon
                    slot="prefix"
                    name="linear-add"
                    label="add"
                  ></I2cIcon>{" "}
                  Add
                </I2cButton>
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">KYC Process </div>
            <div className="custom-label-light mb-16">
              Will KYC procedures be conducted to retain cardholder information
              such as Address, DOB, and ID to meet the applicable legal and
              regulatory compliance requirements?
            </div>
            <div className="single-field-wrapper ">
              <Controller
                name="pf_kyc_process"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_kyc_process")}
                    {...field}
                    name="pf_kyc_process"
                    onI2cChange={(e) => {
                      methods.trigger();
                      if (e.target.value !== "yes") {
                        [
                          "pf_kyc_conduct",
                          "pf_kyc_conduct_other_company",
                          "pf_kyc_conduct_other_contact_name",
                          "pf_kyc_conduct_other_title",
                          "pf_kyc_conduct_other_phone",
                          "pf_kyc_conduct_other_phone_country",
                          "pf_kyc_conduct_other_email",
                          "pf_kyc_conduct_other_address",
                        ].forEach((field) => methods.setValue(field, ""));
                      }
                    }}
                  >
                    {["Yes", "No", "N/A"].map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        onClick={(e) => {
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                        checked={
                          methods.watch("pf_kyc_process") ===
                          cp.toLocaleLowerCase()
                        }
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_kyc_process &&
                    methods.formState.touchedFields.pf_kyc_process
                    ? true
                    : false
                }
                message={errors.pf_kyc_process?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("pf_kyc_process") === "yes" && (
            <>
              <div i2c-grid="12">
                <div className="sub-heading mb-16">Who will conduct KYC?</div>
                <div className="single-field-wrapper ">
                  <Controller
                    name="pf_kyc_conduct"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        label=""
                        value={methods.watch("pf_kyc_conduct")}
                        {...field}
                        name="pf_kyc_conduct"
                        onI2cChange={(e) => {
                          if (e.target.value === "other") {
                            [
                              "pf_kyc_conduct_other_company",
                              "pf_kyc_conduct_other_contact_name",
                              "pf_kyc_conduct_other_title",
                              "pf_kyc_conduct_other_phone",
                              "pf_kyc_conduct_other_phone_country",
                              "pf_kyc_conduct_other_email",
                              "pf_kyc_conduct_other_address",
                            ].forEach((field) => methods.setValue(field, ""));
                          }
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        <div i2c-grid="grid gap-sm">
                          {whoConductKyc.map((conductor, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={conductor}
                              sublabel=" "
                              value=""
                              type="checkbox"
                              checked={
                                methods.watch("pf_kyc_conduct") ===
                                conductor.toLocaleLowerCase()
                              }
                            >
                              <I2cRadio
                                slot="prefix"
                                filled
                                label=""
                                checked={
                                  methods.watch("pf_kyc_conduct") ===
                                  conductor.toLocaleLowerCase()
                                }
                                value={conductor.toLocaleLowerCase()}
                              ></I2cRadio>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cRadioGroup>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.pf_kyc_conduct &&
                        methods.formState.touchedFields.pf_kyc_conduct
                        ? true
                        : false
                    }
                    message={errors.pf_kyc_conduct?.message ?? "Invalid input"}
                  />
                </div>
                {methods.watch("pf_kyc_conduct") === "other" && (
                  <div i2c-grid="12" className="mt-16">
                    <div className="custom-label-light mb-12">
                      If using a 3rd Party Vendor, please provide details
                    </div>
                    <div i2c-grid="grid gap-column-sm gap-row-md">
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyc_conduct_other_company"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Name"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Company Name"
                                name={"pf_kyc_conduct_other_company"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyc_conduct_other_company &&
                              methods.formState.touchedFields
                                .pf_kyc_conduct_other_company
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyc_conduct_other_company?.message ??
                              "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyc_conduct_other_contact_name"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Name"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Contact Name"
                                name={"pf_kyc_conduct_other_contact_name"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyc_conduct_other_contact_name &&
                              methods.formState.touchedFields
                                .pf_kyc_conduct_other_contact_name
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyc_conduct_other_contact_name
                                ?.message ?? "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyc_conduct_other_title"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Title"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Title"
                                name={"pf_kyc_conduct_other_title"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyc_conduct_other_title &&
                              methods.formState.touchedFields
                                .pf_kyc_conduct_other_title
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyc_conduct_other_title?.message ??
                              "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <I2cPhoneField
                            format="NATIONAL"
                            label="Cell Number"
                             show-flags
                            helpIcon=""
                            name="pf_kyc_conduct_other_phone"
                            size="large"
                            country-box
                            selectedCountry={methods.watch(
                              "pf_kyc_conduct_other_phone_country",
                            ) || "US"}
                            errorMessageVisible={false}
                            onI2cChange={(e) => {
                              const country = e.target.country;
                              const isValid = e.target.isValid;
                              const value = e.target.value;
                              methods.setValue(
                                "pf_kyc_conduct_other_phone_country",
                                country,
                              );
                              methods.setValue(
                                "pf_kyc_conduct_other_phone",
                                value,
                              );
                              if (!isValid) {
                                methods.setError("pf_kyc_conduct_other_phone", {
                                  message: e.target.guide,
                                });
                              } else {
                                methods.clearErrors(
                                  "pf_kyc_conduct_other_phone",
                                );
                              }
                              methods.trigger();
                              handleValueChanges();
                            }}
                            value={
                              methods.watch("pf_kyc_conduct_other_phone") ?? ""
                            }
                          />
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyc_conduct_other_email"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Email"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                type="email"
                                label="Email"
                                name={"pf_kyc_conduct_other_email"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyc_conduct_other_email &&
                              methods.formState.touchedFields
                                .pf_kyc_conduct_other_email
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyc_conduct_other_email?.message ??
                              "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <div className="single-field-wrapper">
                            <Controller
                              name="pf_kyc_conduct_other_address"
                              control={control}
                              render={({ field }) => (
                                <I2cTextarea
                                  rows={2}
                                  {...field}
                                  className="single-input-field"
                                  placeholder="Enter Physical Address"
                                  onI2cInput={(e) => {
                                    const value = e.target.value;
                                    field.onChange(value);
                                    methods.trigger();
                                    handleValueChanges();
                                  }}
                                  size="large"
                                  label="Physical Address"
                                  name={"pf_kyc_conduct_other_address"}
                                />
                              )}
                            />
                            <ErrorMessage
                              show={
                                errors.pf_kyc_conduct_other_address &&
                                  methods.formState.touchedFields
                                    .pf_kyc_conduct_other_address
                                  ? true
                                  : false
                              }
                              message={
                                errors.pf_kyc_conduct_other_address?.message ??
                                "Invalid input"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading mb-4">KYB Process </div>
            <div className="custom-label-light mb-16">
              Will KYB (Know Your Business) procedures be conducted to examine
              entities that you wish to onboard.
            </div>
            <div className="single-field-wrapper ">
              <Controller
                label=""
                name="pf_kyb_process"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_kyb_process")}
                    {...field}
                    name="pf_kyb_process"
                    onI2cChange={(e) => {
                      if (e.target.value !== "yes") {
                        [
                          "pf_kyb_responsibility",
                          "pf_kyb_responsibility_other_company",
                          "pf_kyb_responsibility_other_contact_name",
                          "pf_kyb_responsibility_other_title",
                          "pf_kyb_responsibility_other_phone",
                          "pf_kyb_responsibility_other_phone_country",
                          "pf_kyb_responsibility_other_email",
                          "pf_kyb_responsibility_other_address",
                        ].forEach((field) => methods.setValue(field, ""));
                      }
                      methods.trigger();
                    }}
                  >
                    {["Yes", "No", "N/A"].map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        onClick={(e) => {
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                        checked={
                          methods.watch("pf_kyb_process") ===
                          cp.toLocaleLowerCase()
                        }
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_kyb_process &&
                    methods.formState.touchedFields.pf_kyb_process
                    ? true
                    : false
                }
                message={errors.pf_kyb_process?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("pf_kyb_process") === "yes" && (
            <>
              <div i2c-grid="12">
                <div className="sub-heading mb-16">
                  Who will conduct KYB Responsibilities?
                </div>
                <div className="single-field-wrapper ">
                  <Controller
                    name="pf_kyb_responsibility"
                    control={control}
                    render={({ field }) => (
                      <I2cRadioGroup
                        value={methods.watch("pf_kyb_responsibility")}
                        {...field}
                        name="pf_kyb_responsibility"
                        onI2cChange={(e) => {
                          if (e.target.value !== "other") {
                            [
                              "pf_kyb_responsibility_other_company",
                              "pf_kyb_responsibility_other_contact_name",
                              "pf_kyb_responsibility_other_title",
                              "pf_kyb_responsibility_other_phone",
                              "pf_kyb_responsibility_other_phone_country",
                              "pf_kyb_responsibility_other_email",
                              "pf_kyb_responsibility_other_address",
                            ].forEach((field) => methods.setValue(field, ""));
                          }
                          field.onChange(e);
                          methods.trigger();
                          handleValueChanges();
                        }}
                      >
                        <div i2c-grid="grid gap-sm">
                          {whoConductKyc.map((conductor, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={conductor}
                              sublabel=" "
                              value=""
                              type="checkbox"
                              checked={
                                methods.watch("pf_kyb_responsibility") ===
                                conductor.toLocaleLowerCase()
                              }
                            >
                              <I2cRadio
                                slot="prefix"
                                filled
                                label=""
                                checked={
                                  methods.watch("pf_kyb_responsibility") ===
                                  conductor.toLocaleLowerCase()
                                }
                                value={conductor.toLocaleLowerCase()}
                              ></I2cRadio>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cRadioGroup>
                    )}
                  />
                  <ErrorMessage
                    show={
                      errors.pf_kyb_responsibility &&
                        methods.formState.touchedFields.pf_kyb_responsibility
                        ? true
                        : false
                    }
                    message={
                      errors.pf_kyb_responsibility?.message ?? "Invalid input"
                    }
                  />
                </div>
                {methods.watch("pf_kyb_responsibility") === "other" && (
                  <div i2c-grid="12" className="mt-16">
                    <div className="custom-label-light mb-12">
                      If using a 3rd Party Vendor, please provide details
                    </div>
                    <div i2c-grid="grid gap-column-sm gap-row-md">
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyb_responsibility_other_company"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Name"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Company Name"
                                name={"pf_kyb_responsibility_other_company"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyb_responsibility_other_company &&
                              methods.formState.touchedFields
                                .pf_kyb_responsibility_other_company
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyb_responsibility_other_company
                                ?.message ?? "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyb_responsibility_other_contact_name"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Name"

                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Contact Name"
                                name={
                                  "pf_kyb_responsibility_other_contact_name"
                                }
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyb_responsibility_other_contact_name &&
                              methods.formState.touchedFields
                                .pf_kyb_responsibility_other_contact_name
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyb_responsibility_other_contact_name
                                ?.message ?? "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyb_responsibility_other_title"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Title"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                size="large"
                                label="Title"
                                name={"pf_kyb_responsibility_other_title"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyb_responsibility_other_title &&
                              methods.formState.touchedFields
                                .pf_kyb_responsibility_other_title
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyb_responsibility_other_title
                                ?.message ?? "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <I2cPhoneField
                            format="NATIONAL"
                            label="Cell Number"
                            show-flags
                            helpIcon=""
                            name="pf_kyb_responsibility_other_phone"
                            size="large"
                            country-box
                            selectedCountry={methods.watch(
                              "pf_kyb_responsibility_other_phone_country",
                            ) || "US"}
                            errorMessageVisible={false}
                            onI2cChange={(e) => {
                              const country = e.target.country;
                              const isValid = e.target.isValid;
                              const value = e.target.value;
                              methods.setValue(
                                "pf_kyb_responsibility_other_phone_country",
                                country,
                              );
                              methods.setValue(
                                "pf_kyb_responsibility_other_phone",
                                value,
                              );
                              if (!isValid) {
                                methods.setError(
                                  "pf_kyb_responsibility_other_phone",
                                  {
                                    message: e.target.guide,
                                  },
                                );
                              } else {
                                methods.clearErrors(
                                  "pf_kyb_responsibility_other_phone",
                                );
                              }
                              methods.trigger();
                              handleValueChanges();
                            }}
                            value={
                              methods.watch(
                                "pf_kyb_responsibility_other_phone",
                              ) ?? ""
                            }
                          />
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <Controller
                            name="pf_kyb_responsibility_other_email"
                            control={control}
                            render={({ field }) => (
                              <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="Enter Email"
                                onI2cInput={(e) => {
                                  const value = e.target.value;
                                  field.onChange(value);
                                  methods.trigger();
                                  handleValueChanges();
                                }}
                                type="email"
                                size="large"
                                label="Email"
                                name={"pf_kyb_responsibility_other_email"}
                              />
                            )}
                          />
                          {/* <ErrorMessage
                            show={
                              errors.pf_kyb_responsibility_other_email &&
                              methods.formState.touchedFields
                                .pf_kyb_responsibility_other_email
                                ? true
                                : false
                            }
                            message={
                              errors.pf_kyb_responsibility_other_email
                                ?.message ?? "Invalid input"
                            }
                          /> */}
                        </div>
                      </div>
                      <div i2c-grid="4@md">
                        <div className="single-field-wrapper">
                          <div className="single-field-wrapper">
                            <Controller
                              name="pf_kyb_responsibility_other_address"
                              control={control}
                              render={({ field }) => (
                                <I2cTextarea
                                  rows={2}
                                  {...field}
                                  className="single-input-field"
                                  placeholder="Enter Physical Address"
                                  onI2cInput={(e) => {
                                    const value = e.target.value;
                                    field.onChange(value);
                                    methods.trigger();
                                    handleValueChanges();
                                  }}
                                  size="large"
                                  label="Physical Address"
                                  name={"pf_kyb_responsibility_other_address"}
                                />
                              )}
                            />
                            <ErrorMessage
                              show={
                                errors.pf_kyb_responsibility_other_address &&
                                  methods.formState.touchedFields
                                    .pf_kyb_responsibility_other_address
                                  ? true
                                  : false
                              }
                              message={
                                errors.pf_kyb_responsibility_other_address
                                  ?.message ?? "Invalid input"
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip mb-4">
              <div className="sub-heading">Card Order Placement </div>
              <I2cTooltip
                content="Corporate credit card account requests can be sent in through the Partner Portal (C-Partner)."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info" color="#6B7080" ></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="custom-label-light mb-16">
              How will a customer request to order a card and which channels
              will be used to send the card ordering requests?
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_card_order_placement"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup {...field}>
                      <div i2c-grid="grid gap-sm">
                        {cardOrderPlacement.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            checked={methods
                              .watch("pf_card_order_placement")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleCardrequestChecksChanges(card.value);
                            }}
                            type="checkbox"
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={card.value}
                              label=""
                              filled
                              checked={methods
                                .watch("pf_card_order_placement")
                                .includes(card.value)}
                              className="customCheckbox"

                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.pf_card_order_placement &&
                          methods.formState.touchedFields.pf_card_order_placement
                          ? true
                          : false
                      }
                      message={
                        errors.pf_card_order_placement?.message ??
                        "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_card_order_placement_channel"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup label="Select the channels:" {...field}>
                      <div i2c-grid="grid gap-sm">
                        {channel.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            checked={methods
                              .watch("pf_card_order_placement_channel")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleCardrequestChannelsChecksChanges(
                                card.value,
                              );
                            }}
                            type="checkbox"
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={card.value}
                              label=""
                              filled
                              checked={methods
                                .watch("pf_card_order_placement_channel")
                                .includes(card.value)}
                              className="customCheckbox"

                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.pf_card_order_placement_channel &&
                          methods.formState.touchedFields
                            .pf_card_order_placement_channel
                          ? true
                          : false
                      }
                      message={
                        errors.pf_card_order_placement_channel?.message ??
                        "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_card_order_placement_channel")?.includes(5) && (
            <div i2c-grid="6@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_card_order_placement_channel_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Please Specify"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      size="large"
                      label="Other Details"
                      name={"pf_card_order_placement_channel_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_card_order_placement_channel_other &&
                    methods.formState.touchedFields
                      .pf_card_order_placement_channel_other
                      ? true
                      : false
                  }
                  message={
                    errors.pf_card_order_placement_channel_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">Card Activation Channels</div>
            <div className="custom-label-light mb-16">
              Select the i2c Inc. channels/interfaces you want the cardholders
              to use to activate card accounts.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_card_order_placement_channel"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup label="Select the channels:" {...field}>
                      <div i2c-grid="grid gap-sm">
                        {cardActivationChannel.map((card, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="6@md 4@lg"
                            variant="receipt"
                            label={card.label}
                            sublabel=""
                            value=""
                            checked={methods
                              .watch("pf_card_activation_channel")
                              .includes(card.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleCardActivationChannelsChecksChanges(
                                card.value,
                              );
                            }}
                            type="checkbox"
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={card.value}
                              label=""
                              filled
                              checked={methods
                                .watch("pf_card_activation_channel")
                                .includes(card.value)}
                              className="customCheckbox"

                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>  
                    <ErrorMessage
                      show={
                        errors.pf_card_activation_channel &&
                          methods.formState.touchedFields
                            .pf_card_activation_channel
                          ? true
                          : false
                      }
                      message={
                        errors.pf_card_activation_channel?.message ??
                        "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          </div>
          {methods.watch("pf_card_activation_channel")?.includes(5) && (
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_card_activation_channel_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Please Specify"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      size="large"
                      label="Other Details"
                      name={"pf_card_activation_channel_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_card_activation_channel_other &&
                    methods.formState.touchedFields
                      .pf_card_activation_channel_other
                      ? true
                      : false
                  }
                  message={
                    errors.pf_card_activation_channel_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
        </div>
        
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">PIN Management</div>
            <div className="custom-label-light mb-16">
              How will the first card PIN be generated for the card?
            </div>
            <div className="single-field-wrapper ">
              <Controller
                name="pf_pin_management"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_pin_management")}
                    {...field}
                    name="pf_pin_management"
                    onI2cChange={(e) => {
                      if (e.target.value !== "default-pin") {
                        methods.setValue("pf_pin_manage_default_pin", "");
                        methods.setValue("pf_pin_manage_default_pin_other", "");
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {pinManagmentOptions.map((conductor, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md"
                          variant="receipt"
                          label={conductor.label}
                          sublabel=" "
                          value=""
                          type="checkbox"
                          checked={
                            methods.watch("pf_pin_management") ===
                            conductor.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            filled
                            label=""
                            checked={
                              methods.watch("pf_pin_management") ===
                              conductor.value
                            }
                            value={conductor.value}
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pf_pin_management &&
                    methods.formState.touchedFields.pf_pin_management
                    ? true
                    : false
                }
                message={errors.pf_pin_management?.message ?? "Invalid input"}
              />
            </div>
          </div>
          {methods.watch("pf_pin_management") === "default-pin" && (
            <div i2c-grid="12">
              <div className="single-field-wrapper ">
                <Controller
                  name="pf_pin_manage_default_pin"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      label="If you select the default PIN option, please confirm the default PIN value."
                      value={methods.watch("pf_pin_manage_default_pin")}
                      {...field}
                      name="pf_pin_manage_default_pin"
                      onI2cChange={(e) => {
                        if (e.target.value !== "other") {
                          methods.setValue(
                            "pf_pin_manage_default_pin_other",
                            "",
                          );
                        }
                        field.onChange(e);
                        methods.trigger();
                        handleValueChanges();
                      }}
                    >
                      <div i2c-grid="grid gap-sm">
                        {pinManagememt.map((conductor, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={conductor.label}
                            sublabel=" "
                            value=""
                            type="checkbox"
                            checked={
                              methods.watch("pf_pin_manage_default_pin") ===
                              conductor.value
                            }
                          >
                            <I2cRadio
                              slot="prefix"
                              filled
                              label=""
                              checked={
                                methods.watch("pf_pin_manage_default_pin") ===
                                conductor.value
                              }
                              value={conductor.value}
                            ></I2cRadio>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cRadioGroup>
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pf_pin_manage_default_pin &&
                      methods.formState.touchedFields.pf_pin_manage_default_pin
                      ? true
                      : false
                  }
                  message={
                    errors.pf_pin_manage_default_pin?.message ?? "Invalid input"
                  }
                />
              </div>
            </div>
          )}
          {methods.watch("pf_pin_manage_default_pin") === "other" && (
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_pin_manage_default_pin_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Please Specify"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      size="large"
                      label="Other Details"
                      name={"pf_pin_manage_default_pin_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_pin_manage_default_pin_other &&
                    methods.formState.touchedFields
                      .pf_pin_manage_default_pin_other
                      ? true
                      : false
                  }
                  message={
                    errors.pf_pin_manage_default_pin_other?.message ??
                    "Invalid input"
                  }
                /> */}
              </div>
            </div>
          )}
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_pin_mailer"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_pin_mailer")}
                    {...field}
                    name="pf_pin_mailer"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                    label=" If you want to send the PIN through PIN Mailer?"
                  >
                    {["Yes", "No", "N/A"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_pin_mailer") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_offline_pin_support"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_offline_pin_support")}
                    {...field}
                    name="pf_offline_pin_support"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                    label="  Would you like Offline PIN support enabled for your BIN (mainly applicable for EU and Canada)?"
                  >
                    {["Yes", "No", "N/A"].map((type, index) => (
                      <I2cRadioButton
                        key={index}
                        checked={
                          methods.watch("pf_offline_pin_support") ===
                          type.toLocaleLowerCase()
                        }
                        value={type.toLocaleLowerCase()}
                      >
                        {type}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="sub-heading">Consumer Payment Options</div>
            <div className="custom-label-light mb-16">
              Specify the payment options that you wish to enable for your
              cardholders.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_consumer_payment_opt"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup {...field}>
                      <div i2c-grid="grid gap-sm">
                        {constumerPaymentOptions.map((option, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={option.label}
                            sublabel=""
                            value=""
                            checked={methods
                              .watch("pf_consumer_payment_opt")
                              .includes(option.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleConsumerPaymentsChecksChanges(option.value);
                            }}
                            type="checkbox"
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={option.value}
                              label=""
                              filled
                              checked={methods
                                .watch("pf_consumer_payment_opt")
                                .includes(option.value)}
                              className="customCheckbox"

                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>
                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.pf_consumer_payment_opt &&
                          methods.formState.touchedFields.pf_consumer_payment_opt
                          ? true
                          : false
                      }
                      message={
                        errors.pf_consumer_payment_opt?.message ??
                        "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
            {methods.watch("pf_consumer_payment_opt").includes(3) && (
              <div i2c-grid="grid gap-sm" className="mt-16">
                <div i2c-grid="4@md">
                <div className="single-field-wrapper">
                <Controller
                  name="pf_consumer_payment_opt_other"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      size="large"
                      label="Please Specify"
                      name={"pf_consumer_payment_opt_other"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.pf_consumer_payment_opt_other &&
                    methods.formState.touchedFields
                      .pf_consumer_payment_opt_other
                      ? true
                      : false
                  }
                  message={
                    errors.pf_consumer_payment_opt_other?.message ??
                    "Invalid input"
                  }
                /> */}
                </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip mb-16">
              <div className="sub-heading">Lockbox Service</div>
              <I2cTooltip
                content="Lockbox service works by accepting cardholder payments through having the relevant documents mailed to a P.O. Box.
                            Note: For the US region, i2c Inc. is already integrated with AFTS."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info" color="#6B7080" ></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_lockbox_services"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_lockbox_services")}
                    {...field}
                    name="pf_lockbox_services"
                    onI2cChange={(e) => {
                      if (e.target.value !== "other") {
                        [
                          "pf_lockbox_services_other_company",
                          "pf_lockbox_services_other_contact_name",
                          "pf_lockbox_services_other_title",
                          "pf_lockbox_services_other_phone",
                          "pf_lockbox_services_other_phone_country",
                          "pf_lockbox_services_other_email",
                        ].forEach((field) => methods.setValue(field, ""));
                      }
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {lockboxServices.map((type, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={type.label}
                          sublabel=""
                          type="checkbox"
                          checked={
                            methods.watch("pf_lockbox_services") === type.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            name="of_fisco"
                            filled
                            value={type.value}
                            label=""
                          ></I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
            {methods.watch("pf_lockbox_services") === "other" && (
              <div i2c-grid="12" className="mt-16">
                <div className="custom-label-light mb-16">
                  Please specify who will manage this service.
                </div>
                <div i2c-grid="grid gap-column-sm gap-row-md">
                  <div i2c-grid="4@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_lockbox_services_other_company"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Name"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            size="large"
                            label="Company Name"
                            name={"pf_lockbox_services_other_company"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_lockbox_services_other_company &&
                          methods.formState.touchedFields
                            .pf_lockbox_services_other_company
                            ? true
                            : false
                        }
                        message={
                          errors.pf_lockbox_services_other_company?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                  <div i2c-grid="4@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_lockbox_services_other_contact_name"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Name"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            size="large"
                            label="Contact Name"
                            name={"pf_lockbox_services_other_contact_name"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_lockbox_services_other_contact_name &&
                          methods.formState.touchedFields
                            .pf_lockbox_services_other_contact_name
                            ? true
                            : false
                        }
                        message={
                          errors.pf_lockbox_services_other_contact_name
                            ?.message ?? "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                  <div i2c-grid="4@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_lockbox_services_other_title"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Title"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            size="large"
                            label="Title"
                            name={"pf_lockbox_services_other_title"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_lockbox_services_other_title &&
                          methods.formState.touchedFields
                            .pf_lockbox_services_other_title
                            ? true
                            : false
                        }
                        message={
                          errors.pf_lockbox_services_other_title?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                  <div i2c-grid="4@md">
                    <div className="single-field-wrapper">
                      <I2cPhoneField
                        format="NATIONAL"
                        label="Cell Number"
                        helpIcon=""
                        show-flags
                        name="pf_lockbox_services_other_phone"
                        size="large"
                        country-box
                        selectedCountry={methods.watch(
                          "pf_lockbox_services_other_phone_country",
                        ) || "US"}
                        errorMessageVisible={false}
                        onI2cChange={(e) => {
                          const country = e.target.country;
                          const isValid = e.target.isValid;
                          const value = e.target.value;
                          methods.setValue(
                            "pf_lockbox_services_other_phone_country",
                            country,
                          );
                          methods.setValue(
                            "pf_lockbox_services_other_phone",
                            value,
                          );
                          if (!isValid) {
                            methods.setError(
                              "pf_lockbox_services_other_phone",
                              {
                                message: e.target.guide,
                              },
                            );
                          } else {
                            methods.clearErrors(
                              "pf_lockbox_services_other_phone",
                            );
                          }
                          methods.trigger();
                          handleValueChanges();
                        }}
                        value={
                          methods.watch("pf_lockbox_services_other_phone") ?? ""
                        }
                      />
                    </div>
                  </div>
                  <div i2c-grid="4@md">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pf_lockbox_services_other_email"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Enter Email"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              methods.trigger();
                              handleValueChanges();
                            }}
                            size="large"
                            type="email"
                            label="Email"
                            name={"pf_lockbox_services_other_email"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pf_lockbox_services_other_email &&
                          methods.formState.touchedFields
                            .pf_lockbox_services_other_email
                            ? true
                            : false
                        }
                        message={
                          errors.pf_lockbox_services_other_email?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div i2c-grid="grid gap-md" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip mb-16">
              <div className="sub-heading">Minimum Payment Calculation</div>
              <I2cTooltip
                content="Please confirm how the minimum payment will be calculated for this card program."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info" color="#6B7080" ></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="delinquent-fields mb-16">
              <I2cSelect
                placeholder="Percentage of Credit Limit"
                label="Select Primary Calculation Method"
                size="large"
                onI2cChange={(e) => {
                  methods.setValue("pf_min_pc_pcalc_method", e.target.value);
                  handleValueChanges();
                }}
                value={methods.watch("pf_min_pc_pcalc_method")}
              >
                <I2cMenuItem value="Percentage of Credit Limit">
                  Percentage of Credit Limit
                </I2cMenuItem>
              </I2cSelect>
              <div className="fields-flex">
                <Controller
                  name="pf_min_pc_pprcntg_value"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      type="number"
                      className="filled-suffix-input "
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pf_min_pc_pprcntg_value"}
                      label="Define Percentage Value"
                      placeholder="Enter percentage value"
                    >
                      <div slot="suffix" className="btn_color_black">
                        %
                      </div>
                    </I2cInput>
                  )}
                />
                <I2cButton size="large" variant="tertiary gray" disabled>
                  <I2cIcon name="linear-trash" label="delete"></I2cIcon>
                </I2cButton>
              </div>
            </div>
            {methods.watch("pf_min_pc_scalc_method").length ||
              secondaryMethods ? (
              <div key={"pf_min_pc_scalc_method"} className="delinquent-fields mb-16">
                <I2cSelect
                  placeholder="Secondary Method"
                  label="Select Secondary Calculation Method"
                  size="large"
                  onI2cChange={(e) => {
                    methods.setValue("pf_min_pc_scalc_method", e.target.value);
                    handleValueChanges();
                  }}
                  value={methods.watch("pf_min_pc_scalc_method")}
                >
                  <I2cMenuItem value="Percentage of Credit Limit">
                    Percentage of Credit Limit
                  </I2cMenuItem>
                </I2cSelect>
                <div className="fields-flex">
                  <Controller
                    name="pf_min_pc_sprcntg_value"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        type="number"
                        className="filled-suffix-input "
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        name={"pf_min_pc_sprcntg_value"}
                        label="Define Percentage Value"
                        placeholder="Enter percentage value"
                      >
                        <div slot="suffix" className="btn_color_black">
                          %
                        </div>
                      </I2cInput>
                    )}
                  />
                  <I2cButton
                    size="large"
                    variant="tertiary gray"
                    onClick={() => {
                      methods.setValue("pf_min_pc_scalc_method", "");
                      methods.setValue("pf_min_pc_sprcntg_value", "");
                      setShowSecondaryMethod(false);
                      handleValueChanges();
                    }}
                  >
                    <I2cIcon name="linear-trash" label="delete"></I2cIcon>
                  </I2cButton>
                </div>
              </div>
            ) : (
              ""
            )}
            {!methods.watch("pf_min_pc_scalc_method").length &&
              !secondaryMethods ? (
              <div className="mb-16">
                <I2cButton
                  size="small"
                  variant="link color"
                  onClick={handleAddSecondary}
                >
                  <I2cIcon
                    slot="prefix"
                    name="linear-add"
                    label="add"
                  ></I2cIcon>
                  Add Secondary Method
                </I2cButton>
              </div>
            ) : (
              ""
            )}
            <div i2c-grid="grid gap-sm" className="mb-16">
              <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="pf_min_payment_threshold"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Minimum Payment Threshold"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      size="large"
                      label="Minimum Payment Threshold"
                      name={"pf_min_payment_threshold"}
                    />
                  )}
                />
              </div>
              </div>
            </div>
            <div className="custom-label-light mb-8">
              Select additional amounts to be included in the minimum payment.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_min_payment_additional_amount"
                control={control}
                render={({ field }) => (
                  <I2cCheckboxGroup {...field}>
                    <div i2c-grid="grid gap-sm">
                      {additionalPayment.map((type, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="6@md 4@lg"
                          variant="receipt"
                          label={type.label}
                          sublabel=""
                          value=""
                          checked={methods
                            .watch("pf_min_payment_additional_amount")
                            .includes(type.value)}
                          onI2cCheckboxClicked={(e) => {
                            handleMinPaymentAdditionalAmountChanges(
                              type.value,
                            );
                          }}
                          type="checkbox"
                        >
                          <I2cCheckbox
                            slot="prefix"
                            value={type.value}
                            label=""
                            filled
                            checked={methods
                              .watch("pf_min_payment_additional_amount")
                              .includes(type.value)}
                            className="customCheckbox"

                          ></I2cCheckbox>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cCheckboxGroup>

                )}
              />
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="organize-tooltip mb-16">
              <div className="sub-heading">Payment Distribution Options</div>
              <I2cTooltip
                content="Note: For the manual distribution option, client will be required to provide the order in which the system will allocate payments against various components that make up the statement balance."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info" color="#6B7080" ></I2cIcon>
              </I2cTooltip>
            </div>
            <div className=" custom-label mb-16">
              Distribution options for payments greater than the minimum.
            </div>
            <div className="single-field-wrapper">
              <Controller
                name="pf_payment_dist_opt_greater_min"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pf_payment_dist_opt_greater_min")}
                    {...field}
                    name="pf_payment_dist_opt_greater_min"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {paymentDistributionOpt.map((option, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          className="cardlist-custom-direction"
                          label={option.label}
                          sublabel=" "
                          option="checkbox"
                          checked={
                            methods.watch("pf_payment_dist_opt_greater_min") ===
                            option.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            name="of_fisco"
                            filled
                            value={option.value}
                            label=""
                          ></I2cRadio>
                          {option.tooltip !== "" && (
                            <I2cTooltip
                              slot="suffix"
                              hoist
                              content={option.tooltip}
                              placement="right-start"
                            >
                              <I2cIcon name="cs-linear-help-circle" color="#A1A3AE"></I2cIcon>
                            </I2cTooltip>
                          )}
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="pf_payment_dist_opt_for_min"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    label="Distribution options for the minimum payment."
                    value={methods.watch("pf_payment_dist_opt_for_min")}
                    {...field}
                    name="pf_payment_dist_opt_for_min"
                    onI2cChange={(e) => {
                      field.onChange(e);
                      methods.trigger();
                      handleValueChanges();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {distributionMinimumPay.map((option, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          className="cardlist-custom-direction"
                          label={option.label}
                          sublabel=" "
                          option="checkbox"
                          checked={
                            methods.watch("pf_payment_dist_opt_for_min") ===
                            option.value
                          }
                        >
                          <I2cRadio
                            slot="prefix"
                            name="of_fisco"
                            filled
                            value={option.value}
                            label=""
                          ></I2cRadio>
                          {option.tooltip !== "" && (
                            <I2cTooltip
                              slot="suffix"
                              hoist
                              content={option.tooltip}
                              placement="right-start"
                            >
                              <I2cIcon name="cs-linear-help-circle" color="#A1A3AE"></I2cIcon>
                            </I2cTooltip>
                          )}
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreditLimits;
